import React from "react";
import PropTypes from "prop-types";
import { fromJS } from "immutable";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import {
  DataTable,
  Icon,
  SearchPropTypes,
  CompanyName,
  PartNumber,
  LocationFlag
} from "MODULES/shared/components";
import { getConditionAbbrev } from "MODULES/RepairOrders/constants";
import {
  CONDITION,
  INVENTORY,
  SERIAL_NUMBER
} from "MODULES/inventories/constants";
import { DESCRIPTION, PART } from "MODULES/parts/constants";
import { CANCELLED, CODE, CREATED_AT, ID, UUID } from "APP_ROOT/constants";
import { MANAGED_REPAIR_ORDER } from "MODULES/ManagedRepairOrders/constants";
import { BUYING_STORE_ID } from "MODULES/PurchaseOrders/constants";
import { percent } from "LIB/formatters/number";

function renderRow(result, pushHistory) {
  const lineItem = fromJS(result);
  const rowClasses = classNames("clickable", {
    "cancelled-item": lineItem.get(CANCELLED)
  });

  return (
    <tr
      key={lineItem.get(ID)}
      className={rowClasses}
      onClick={() =>
        pushHistory(
          `/managed-repair-orders/${lineItem.getIn([
            MANAGED_REPAIR_ORDER,
            UUID
          ])}`
        )}
    >
      <td>
        {lineItem.getIn([MANAGED_REPAIR_ORDER, CODE])}{" "}
        {lineItem.get(CANCELLED) && (
          <span className="text-muted">
            <Icon name="ban" />
          </span>
        )}
      </td>
      <td>{shortDate(lineItem.get(CREATED_AT))}</td>
      <td>
        <CompanyName
          flattenedCompany={lineItem.toJS()}
          context="repair"
          truncateAt={25}
        />
      </td>
      <td>{lineItem.getIn([PART, DESCRIPTION])}</td>
      <td className="text-center">
        <LocationFlag
          location={lineItem.getIn([MANAGED_REPAIR_ORDER, BUYING_STORE_ID])}
        />
      </td>
      <td>
        <PartNumber part={lineItem.toJS().part} />
      </td>
      <td>
        <Link
          onClick={e => e.stopPropagation()}
          to={`/inventories/${lineItem.getIn([INVENTORY, UUID])}`}
        >
          {lineItem.getIn([INVENTORY, SERIAL_NUMBER])}
        </Link>
      </td>
      <td>{getConditionAbbrev(lineItem.get(CONDITION))}</td>
      <td>{dollars(lineItem.get("subtotal"))}</td>
      <td className="text-center">{percent(lineItem.get("markup"), 100)}</td>
      <td>{dollars(lineItem.get("price"))}</td>
    </tr>
  );
}

export function Table({ pushHistory, isLoading, pageActions, results }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>RO #</th>
        <th>Date Created</th>
        <th>Company</th>
        <th>Description</th>
        <th className="text-center">Store Owner</th>
        <th>Part #</th>
        <th>Serial #</th>
        <th>CD</th>
        <th>Repair Fee</th>
        <th className="text-center">Markup</th>
        <th>Managed Repair Fee</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, {
  pushHistory: push
})(Table);



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Search/Table.jsx